import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { MatchesModalSchema } from '@/views/sports/components/MatchesModal/styles/MatchesModal.styles';

export const matchesModalStyles: MatchesModalSchema = {
  modalWrapper: { size: 'lg', isCentered: true, scrollBehavior: 'inside' },
  modalContent: {
    color: 'white',
    overflow: 'hidden',
    bgGradient: 'linear(to-b, beta.400, beta.500)',
    boxShadow:
      '0px 4px 8px 0px rgba(0, 0, 0, 0.25), 0px 0px 20px 0px rgba(0, 216, 255, 0.15) inset, 0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset',
  },
  modalHeader: {
    alignItems: 'center',
    borderBottom: '1px',
    borderColor: 'blackAlpha.300',
    display: 'flex',
    gap: '4',
    justifyContent: 'space-between',
    p: '4',
    fontWeight: 'medium',
    fontSize: 'lg',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.05)',
    fontFamily: 'accent',
  },
  closeButton: {
    bg: 'white',
    color: 'beta.400',
    isRound: true,
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: { bg: 'whiteAlpha.800' },
  },
  divider: {
    as: 'div',
    borderColor: 'blackAlpha.300',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
  },
  modalBody: { p: '0', maxH: '400px' },
  stackWrapper: { spacing: '0' },
  linkWrapper: {
    alignItems: 'center',
    display: 'flex',
    gap: '3',
    justifyContent: 'space-between',
    p: '3',
    mx: '3px',
    _last: { mb: '3px' },
    _hover: { bg: 'beta.600', textDecoration: 'none' },
  },
  flexSportName: {
    align: 'center',
    fontSize: 'sm',
    fontWeight: 'medium',
    gap: '1',
    color: 'white',
  },
  iconSportName: { fontSize: '2xl', color: 'beta.100', sx: {} },
  hStack: {
    spacing: '1',
    sx: {
      '.chakra-badge': {
        lineHeight: 'normal',
      },
    },
  },
  countdown: {
    color: 'inherit',
    fontSize: '9px',
    h: '16px',
    py: '0',
    sx: {
      '&&': {},
    },
  },
  duotoneSgmLogoOverride: {
    h: 'auto',
    w: '9',
    color: 'alpha.200',
  },
  hStackIcon: {
    as: ChevronRight,
    color: 'white',
    fontSize: '2xl',
    sx: {},
  },
};
